import PigmentService from 'services/PigmentService';
import qs from 'qs';
import ProductSheetFavoritesService from 'services/ProductSheetFavoritesService';
import * as types from './mutation-types';

export default {
  async loadPigment({ state, commit, getters }) {
    const pigment = await PigmentService.getOne(state.productBaseInfo.id, state.activeIndustry, getters['user/token']);
    commit(types.SET_PIGMENT, pigment);
  },
  async changeIndustry({ commit, dispatch }, industry) {
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    params.i = industry;
    const urlParams = `?${qs.stringify(params, { encode: false })}`;
    const newUrl = location.search
      ? location.href.replace(location.search, urlParams)
      : `${location.href}${urlParams}`;

    history.replaceState({}, null, newUrl);

    commit(types.SET_INDUSTRY, industry);
    dispatch('loadPigment');
  },
  async fetchDocumentFavorites({ state, getters, commit }) {
    const favorite = await ProductSheetFavoritesService.getForUserAndProduct(getters['user/token'], state.productBaseInfo.prd);

    if (favorite && favorite.length > 0) {
      commit(types.SET_DOCUMENT_FAVORITE, favorite[0]);
    }
  },
  async saveDocumentFavorite({ state, getters, commit }, payload) {
    const favorite = await ProductSheetFavoritesService.saveFavorite(getters['user/token'], state.productBaseInfo.prd, payload.documentTypes);
    commit(types.SAVE_DOCUMENT_FAVORITE, favorite);
  },
  async deleteDocumentFavorite({ state, getters, commit }) {
    await ProductSheetFavoritesService.deleteFavorite(getters['user/token'], state.documentFavorite.id);
    commit(types.DELETE_DOCUMENT_FAVORITE);
  }
};
